import script from "./TressCartQuantitySelector.vue?vue&type=script&lang=ts&setup=true"
export * from "./TressCartQuantitySelector.vue?vue&type=script&lang=ts&setup=true"

import "./TressCartQuantitySelector.vue?vue&type=style&index=0&id=031179c6&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-031179c6"]])

export default __exports__